/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    LandingUserRequest,
} from '../models';

export interface LandingApiControllerCreateLandingUserRequest {
    landingUserRequest: LandingUserRequest;
}

/**
 * 
 */
export class LandingApi extends runtime.BaseAPI {

    /**
     */
    async landingApiControllerCreateLandingUserRaw(requestParameters: LandingApiControllerCreateLandingUserRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.landingUserRequest === null || requestParameters.landingUserRequest === undefined) {
            throw new runtime.RequiredError('landingUserRequest','Required parameter requestParameters.landingUserRequest was null or undefined when calling landingApiControllerCreateLandingUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/landing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.landingUserRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async landingApiControllerCreateLandingUser(requestParameters: LandingApiControllerCreateLandingUserRequest): Promise<void> {
        await this.landingApiControllerCreateLandingUserRaw(requestParameters);
    }

}
